import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal";

class SuggestUpgrade extends React.Component {
  async componentDidMount() {
    const { api } = this.props;
    const { locals } = this.context;
    const hideHeader = locals.query.hideHeader;
    if (hideHeader && api) {
      await api(`upgrade-from-ios`, {
        method: "PUT",
        body: { action: "add" },
      });
    }
  }
  render() {
    const hideHeader = this.context.locals.query.hideHeader;
    return (
      <Modal width="600px">
        <div className="head">
          <h2 className="alt">Upgrade Account</h2>
        </div>

        <div className="body">
          <p>
            A premium subscription is needed to access Premium programs. Our
            Premium programs are expert designed training programs designed by
            our curated list of top athletes and coaches.
          </p>
        </div>

        {!hideHeader && (
          <div className="foot">
            <a href="/dashboard/settings/subscription">
              {" "}
              <button className="button-input full">
                Manage Subscription
              </button>{" "}
            </a>
          </div>
        )}
      </Modal>
    );
  }
}

SuggestUpgrade.contextTypes = { locals: PropTypes.object };

export default SuggestUpgrade;
